<template>
    <div class="stored-record">
        <wallet-stored-info v-if="modalStatus.walletStoredInfo"></wallet-stored-info>
        <div v-if="verifiedState!=5" class="alarm">
            <span v-if="verifiedState == 1">您必須先通過認證房東，才能儲值。<router-link :to="{ name: 'MemberCenter'}">認證房東  <img src="@/assets/img/icon/arrow_right_orange.svg" alt=""></router-link></span>
            <span v-if="verifiedState == 2">資料未填</span>
            <span v-if="verifiedState == 3">資料已填但未上傳證件</span>
            <span v-if="verifiedState == 4">房東認證中，審核完成即可儲值</span>
            <span v-if="verifiedState == 5">已通過認證房東審核，可以儲值囉</span>
            <span v-if="verifiedState == 6">審查未通過</span>
            <span v-if="verifiedState == 7">帳號停用</span>
        </div>
        <div class="wallet-tool-bar">
            <div class="filter" :class="{'fixed': listIsFixed}">
                <!-- <rent-select refName="payWay" selectMsg="所有方式" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                    <ul>
                        <li data-id="ATM">審核通過</li>
                        <li data-id="WALLET">審核失敗</li>
                    </ul>
                </rent-select> -->
                <date-picker v-model="filter.date" :class="{'active': filter.date.length != 0}" placeholder="請選擇日期" format="YYYY.MM.DD"  rangeSeparator="-" range  ></date-picker>
            </div>
            <div class="stored">
                <div class="money">
                    <span class="sign">
                        帳戶餘額
                    </span>
                    <div class="number">
                        {{toCurrency(userTotalBalance)}}
                    </div>
                </div>
                <button v-if="verifiedState == 5" class="default-button" @click="storedEvent()">儲值</button>
            </div>
        </div>
        
        <div class="table-list">
                <div class="table-list-title">
                    <span class="date">時間</span>
                    <span class="pay-way">付款方式</span>
                    <span class="price">儲值金額</span>
                    <span class="state">儲值狀態</span>
                    <span class="num">儲值編號</span>
                </div>
                <div class="table-list-body" >
                    <div v-show="filterByDate.length == 0 && storedRecordList.length != 0" class="filter-empty">
                        <span>0 個搜尋結果</span>
                        <button class="default-button" @click="setFilterDefault">清除篩選</button>
                    </div>
                    <div v-if="storedRecordList.length == 0" class="is-empty">0 筆資料</div>
                    <ul>
                        <li v-for="(list,index) in filterByDate" :key="index">
                            <span class="date">{{getFormatDate(list.createdDate)}}</span>
                            <span class="pay-way">匯款帳號</span>
                            <span class="price">{{toCurrency(list.amount)}}</span>
                            <span class="state blue" v-if="list.transactionStatus == 'SUCCESS'">成功</span>
                            <span class="state red" v-else >失敗</span>
                            <!-- <span class="state gray">等待中</span> -->
                            <span class="num">{{transIdEncrypt(list.transactionId)}}</span>
                        </li>
                    </ul>
                </div> 
        </div>
    </div>
</template>
<script>
import RentSelect from '@/components/widge/RentSelect.vue';
import DatePicker from 'vue2-datepicker';
import walletStoredInfo from '@/components/widge/modal/walletStoredInfo.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            isDefault: false,
            filter: {
                payWay: null,
                date: []
            },
            listIsFixed: false
        }
    },
    mounted () {
        this.$store.dispatch('getStoredRecord')
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll (event) {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                // console.log(scrollTop)
            
                if( scrollTop >= 255){
                    this.listIsFixed = true
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }
            }
        },
        storedEvent: function () {
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
            this.$store.dispatch('setModalStatus', {state: true, type: 'walletStoredInfo'})
            this.$analytics.logEvent('儲值錢包', { screen_name: '儲值錢包'})
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
        transIdEncrypt: function (id) {
            return id.substr(0,5)+'...'
        },
        getSelectId: function (value) {
            this.isDefault = false
            if( value.ref == 'source' ){
                this.filter.source = value.id
            }else if( value.ref == 'payWay' ){
                this.filter.payWay = value.id
            }
        },
        setFilterDefault: function () {
            this.filter = {
                source: null,
                payWay: null,
                date: []
            }
            this.isDefault = true
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            formatDate[5] = (Array(2).join(0)+date.getSeconds()).slice(-2);
            //月及天兩位數
            formatDate[6] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[7] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            // if(formatDate[3] - 8 < 0){
            //     formatDate[3] = 24+(formatDate[3]-8);
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }else{
            //     formatDate[3] = formatDate[3]-8;
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }
            return formatDate[0]+'-'+formatDate[6]+'-'+formatDate[7]+' '+formatDate[3]+':'+formatDate[4];
        },
    },
    computed: {
        filterByDate: function () {
            return this.storedRecordList.filter((item) => {
                if( this.filter.date[0] && this.filter.date[1] ){
                    let storedDate = item.createdDate,
                        filterDateStart = Date.parse(this.filter.date[0]).valueOf(),
                        filterDateEnd = Date.parse(this.filter.date[1]).valueOf()+86400000
                    if( filterDateStart <= storedDate && storedDate <= filterDateEnd ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
    
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
            verifiedState: 'GET_USER_STATUS',
            userTotalBalance: 'GET_USER_TOTAL_BALANCE',
            storedRecordList: 'GET_STORE_RECORD_LIST',
            isModalMode: 'GET_MODAL_MODE'
        })
    },
    components: {
        RentSelect,
        DatePicker,
        walletStoredInfo
    }
}
</script>
<style lang="scss" scoped>
    .stored-record{
        // padding: 0 30px;
        .alarm {
            border-radius: 0 !important;
            padding: 20px 30px;
            margin-bottom: 20px;
        }
        .wallet-tool-bar{
            padding: 0px 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;
            .filter.fixed{
                position: fixed;
                z-index: 50;
                margin-left: 785px;
                background: #fff;
                top: 0px;
                height: 80px;
                align-items: center;
            }
            .filter{
                display: flex;
                .rent-select{
                    width: 75px;
                }
                .mx-datepicker{
                    width: 214px;
                    // margin-left: 16px;
                    input{
                        width: 100%;
                        height: 44px;
                        border-radius: 4px;
                        border: solid 1px #e0dfde;
                        color: #a8a5a4;
                        padding: 13px 16px;
                        box-shadow: none;
                        margin-bottom: 0px;
                    }
                    .mx-icon-calendar,
                    .mx-icon-clear{
                        right: 14px;
                    }
                }
                .mx-datepicker:hover,
                .mx-datepicker.active{
                    input{
                        border: 1px solid #676362 !important;
                        color: #676362 !important;
                    }
                    i{
                        color: #676362;
                    }
                }
            }
            .stored{
                display: flex;
                .money{
                    position: relative;
                    display: flex;
                    align-items: center;
                    margin-right: 16px;
                    .sign{
                        color: #292625;
                        margin-right: 4px;
                    }
                    .number{
                        color: #ff9275;
                        margin-left: 6px;
                        font-size: 28px;
                    }
                }
                .default-button{
                    width: 120px;
                }
            }
        }
        >.table-list{
            position: relative;
            width: 1094px;
            border-radius: 0px;
            border: 0px;
            margin: 0px 30px;
            // border-bottom: 1px solid #f0f0f0;
            border-top: 1px solid #f0f0f0;
            .table-list-title {
                padding: 10px 30px;
                >span{
                    display: flex;
                    align-items: center;
                }
            }
            .table-list-title .date,
            .table-list-body ul li .date{
                position: relative;
                width: 120px;
                margin-right: 220px;
            }
            .table-list-title .pay-way,
            .table-list-body ul li .pay-way{
                width: 60px;
                margin-right: 70px;
            }
            .table-list-title .price,
            .table-list-body ul li .price{
                text-align: right;
                width: 75px;
                margin-right: 80px;
            }
            .table-list-body ul li .price{
                color: #ff9275;
            }
            .table-list-title .state,
            .table-list-body ul li .state{
                width: 76px;
                margin-right: 228px;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 38px;
                border-radius: 4px;
            }
            .table-list-body ul li .state.blue{
                background-color: #f0f6fc;
                color: #71aae5;
            }.table-list-body ul li .state.red{
                background-color: rgba(240, 90, 62, 0.1);
                color: #fc7171;
            }.table-list-body ul li .state.gray{
                background-color: #f6f6f6;
                color: #a8a5a4;
            }
            .table-list-title .num,
            .table-list-body ul li .num{
                width: 117px;
            }
            // .table-list-title .date,
            // .table-list-body ul li .date{
            //     width: 72px;
            // }
        }
    }
    @media screen and (max-width: 1280px) {
        .stored-record{
            .wallet-tool-bar{
                .filter.fixed{
                    margin-left: 897px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/memberCenter/memberWallet/storedRecord.vue